module.exports = "<span data-ng-message=required>*required, at least one tier level selection required to create an assessment</span> ";